<div class="container">
  <div class="container-client">
    <div class="header">
      <h1 class="title">{{'PROJECTS' | translate}}</h1>
      <button class="btn btn-outline-primary primary-btn" (click)="setCreatingProjects()">{{'CREATE' | translate}}</button>
    </div>

    <div class="form-card">
      <div class="loading" *ngIf="loading">
        <div class="spinner-border" role="status"></div>
      </div>

      <div *ngIf="showNoProjectsMessage && !loading" class="no-orders">
        <span> {{'NO_PROJECTS' | translate}}</span>
      </div>

      <table *ngIf="!loading && projects.length > 0" class="table table-bordered table-hover">
        <thead>
            <th scope="col" class="table-start">{{'PROJECT_NAME' | translate}}</th>
            <th scope="col"> {{'PROJECT_ID' | translate}}</th>
            <th scope="col"> {{'EDIT' | translate}}</th>
            <th scope="col">Recursos</th>
            <th scope="col" class="table-end"> {{'DELETE' | translate}}</th>
        </thead>
        <tbody>
          <tr *ngFor="let project of projects">
            <td>{{ project.projectName || 'Sin nombre' }}</td>
            <td>{{ project.projectId }}</td>
            <td>
              <button type="button" class="primary-btn" (click)="editProject(project.externalId)">
                {{'EDIT' | translate}}
              </button>
            </td>
            <td>
              <button type="button" class="btn-confirm" (click)="viewResources(project)">
                {{'VIEW_RESOURCES' | translate}}
              </button>
            </td>
            <td>
              <button class="btn btn-primary remove-btn" (click)="deleteProject(project.projectId, project.timekitProjectId)">
                {{'DELETE' | translate}}
              </button>
              </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<div class="modal fade" id="resourcesModal" tabindex="-1">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{'RESOURCES' | translate}} - {{ selectedProject?.projectName }}</h5>
      </div>
      <div class="modal-body">
        <div class="loading" *ngIf="loadingResources">
          <div class="spinner-border" role="status"></div>
        </div>

        <div *ngIf="!loadingResources && allResources.length === 0" class="alert alert-info">
          {{'NO_RESOURCES_FOUND' | translate}}
        </div>

        <table *ngIf="!loadingResources && allResources.length > 0" class="table table-bordered table-hover">
          <thead>
            <th scope="col" class="table-start">{{'RESOURCE_NAME' | translate}}</th>
            <th scope="col">{{'RESOURCE_ID' | translate}}</th>
            <th scope="col" class="table-end">{{'ACTION' | translate}}</th>
          </thead>
          <tbody>
            <tr *ngFor="let resource of allResources">
              <td>{{ resource.resourceName }}</td>
              <td>{{ resource.resourceId }}</td>
              <td>
                <button *ngIf="isResourceLinked(resource)" type="button" class="btn btn-primary remove-btn"
                  (click)="deleteResource(resource.resourceId, resource.timekitResourceId)">
                  {{'DELETE' | translate}}
                </button>
                <button *ngIf="!isResourceLinked(resource)" type="button" class="primary-btn"
                  (click)="addResourceToProject(resource)">
                  {{'ADD_RESOURCE' | translate}}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn-confirm" (click)="closeResourcesModal()">{{'CLOSE' | translate}}</button>
      </div>
    </div>
  </div>
</div>

<app-loading-modal [visible]="showStatusModal" [status]="statusModalType" [message]="statusModalMessage"
  (closed)="onModalClosed()">
</app-loading-modal>
